/**
 * Een kompasrichting in woorden.
 *
 * Regel voor regel dezelfde tabel als Compass.kt op Android. Bestaat omdat
 * "geldt voor richting 287°" niemand iets zegt en "richting west" wel — en
 * omdat een bestuurder de keuze tussen twee rijrichtingen alleen kan maken als
 * er een woord bij staat dat hij van de borden kent.
 */
const PUNTEN = ["noord", "noordoost", "oost", "zuidoost",
                "zuid", "zuidwest", "west", "noordwest"];

/** Naar acht punten afgerond. Fijner dan dat is een schijnnauwkeurigheid. */
export const compassName = (deg) => {
  if (deg === null || deg === undefined || Number.isNaN(Number(deg))) return null;
  const heel = ((Number(deg) % 360) + 360) % 360;
  return PUNTEN[Math.round(heel / 45) % 8];
};

export const opposite = (deg) =>
  deg === null || deg === undefined || Number.isNaN(Number(deg))
    ? null
    : ((Number(deg) % 360) + 540) % 360;
